// extracted by css-extract-rspack-plugin
export default {"headerWrapper":"xPfiOtCMIcIwleDV","userInfoBlockWrapper":"ebS4zGVgNpEVvEol","userInfoContainer":"OqGAORYnIo00ECZP"};